import { render, staticRenderFns } from "./listaPostales.vue?vue&type=template&id=4d2275c5&scoped=true"
import script from "./listaPostales.vue?vue&type=script&lang=js"
export * from "./listaPostales.vue?vue&type=script&lang=js"
import style0 from "./listaPostales.vue?vue&type=style&index=0&id=4d2275c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2275c5",
  null
  
)

export default component.exports